/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const ContentProps = PropTypes.shape({
    title: PropTypes.string,
    paragraphs: PropTypes.arrayOf(PropTypes.string),
});

export const ContentDefaults = {
    title: '',
    paragraphs: [],
};

export const ContentsProps = PropTypes.objectOf(PropTypes.arrayOf(ContentProps));

export const ContentsDefaults = {};
